var exports = {
  "Gt": "OutlineFrame.module__frame___dndGdl",
  "iv": "OutlineFrame.module__frameShowTop___dndGdl",
  "$D": "OutlineFrame.module__frameHideTop___dndGdl",
  "FG": "OutlineFrame.module__contentWrapper___dndGdl",
  "yF": "OutlineFrame.module__divider___dndGdl",
  "rf": "OutlineFrame.module__body___dndGdl",
};

module.exports = exports;
